import { render, staticRenderFns } from "./IntegralOrderDetail.vue?vue&type=template&id=07df3b18&scoped=true"
import script from "./IntegralOrderDetail.vue?vue&type=script&lang=js"
export * from "./IntegralOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./IntegralOrderDetail.vue?vue&type=style&index=0&id=07df3b18&lang=scss"
import style1 from "./IntegralOrderDetail.vue?vue&type=style&index=1&id=07df3b18&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df3b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07df3b18')) {
      api.createRecord('07df3b18', component.options)
    } else {
      api.reload('07df3b18', component.options)
    }
    module.hot.accept("./IntegralOrderDetail.vue?vue&type=template&id=07df3b18&scoped=true", function () {
      api.rerender('07df3b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/integralOrder/IntegralOrderDetail.vue"
export default component.exports